import * as fetchIntercept from "fetch-intercept";

export const AuthInterceptor = (keycloakObj: any) => {
  const unregister = fetchIntercept.register({
    request: async function (url, config) {
      if (keycloakObj) {
        const exp = keycloakObj?.idTokenParsed?.exp;
        const auth = keycloakObj?.idTokenParsed?.auth_time;

        try {
          const date = new Date(exp * 1000);
          // console.log("date=", date);
          const auth_date = new Date(auth * 1000);
          // console.log("auth_date=", auth_date);
          if (date < new Date()) {
            console.log("token expired, updating it");
            await keycloakObj.updateToken(-1);
          }
        } catch {}

        // console.log("keycloak2-obj=", keycloakObj)
        // console.log("keycloak2-token=", keycloakObj.token)
        config.headers = {
          ...config.headers,
          Authorization: "Bearer " + keycloakObj.token,
        };
      }

      return [url, config];
    },

    requestError: function (error) {
      // Called when an error occured during another 'request' interceptor call

      return Promise.reject(error);
    },

    response: function (response) {
      // Modify the reponse object
      return response;
    },

    responseError: function (error) {
      // Handle an fetch error
      console.log("error=", error);
      if (error?.status === 401) {
        console.warn("Unauthorized response intercepted");
      }
      return Promise.reject(error);
    },
  });
  return unregister;
};
